<div class="image-dnd" fxLayout="column" fxLayoutGap="15px">
  <div
    class="image-dnd__dropzone"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayoutGap="8px"
    [class.image-dnd__dropzone--disabled]="disabled"
    (click)="!disabled && imageInput.click()">

    <input
      #imageInput
      type="file"
      hidden
      [multiple]="multiple"
      [accept]="acceptMime"
      [disabled]="disabled"
      (change)="onImagesSelect($any($event.target).files); imageInput.value = ''">

    <mat-icon>cloud_upload</mat-icon>

    <div>Upuść zdjęcia lub kliknij, aby wybrać</div>

    <small>
      JPG, PNG, WEBP. Maksymalnie {{ maxSize / 1024 / 1024 | number:'1.0-0' }} MB na zdjęcie.
      Łącznie maksymalnie {{ maxTotalSize / 1024 / 1024 | number:'1.0-0' }} MB.
    </small>
  </div>
  <div class="image-dnd__summary" *ngIf="images.length > 0">
    Łączny rozmiar nowych zdjęć:
    <strong>{{ formatBytes(totalEncodedSize) }}</strong>
    / {{ formatBytes(maxTotalSize) }}
  </div>

  <div class="image-dnd__errors" *ngIf="errors.length > 0">
    <div *ngFor="let error of errors">
      {{ error }}
    </div>
  </div>
  <div
    cdkDropList
    class="image-dnd__list"
    [cdkDropListData]="images"
    (cdkDropListDropped)="dropImage($event)">

    <div
      class="image-dnd__item"
      *ngFor="let image of images; let i = index"
      cdkDrag
      [cdkDragDisabled]="disabled">

      <div class="image-dnd__drag" cdkDragHandle>
        <mat-icon>drag_indicator</mat-icon>
      </div>

      <div class="image-dnd__preview">
        <img
          [src]="image.previewUrl"
          [alt]="i === 0 ? 'Zdjęcie główne' : 'Zdjęcie dodatkowe'">
      </div>

      <div class="image-dnd__content">
        <strong>{{ i === 0 ? 'Zdjęcie główne' : 'Zdjęcie dodatkowe' }}</strong>
        <span>Pozycja: {{ i + 1 }}</span>
        <small *ngIf="image.filename">{{ image.filename }}</small>
        <small *ngIf="image.size">
          Plik: {{ formatBytes(image.size) }},
          po base64: {{ formatBytes(image.encodedSize || 0) }}
        </small>
      </div>

      <span fxFlex></span>

      <button
        mat-icon-button
        color="warn"
        type="button"
        [disabled]="disabled"
        (click)="removeImage(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>

  <app-detail
    *ngIf="images.length === 0"
    header="Zdjęcia"
    value="Brak zdjęć">
  </app-detail>
</div>
